var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('Echart',{attrs:{"options":_vm.options,"id":"bottomLeftChart","height":"450px","width":"100%"},on:{"getParams":_vm.getParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }